
import React from 'react';
import { FormFieldType } from '@/types/form';
import { fieldComponents } from '../fields';
import FormField from '../FormField';

interface StandardFormSectionProps {
  elements: FormFieldType[];
  documentUrls?: string[];
}

const StandardFormSection: React.FC<StandardFormSectionProps> = ({ elements, documentUrls = [] }) => {
  return (
    <div className="space-y-6">
      {elements.map((element) => {
        return (
          <div key={element.id} className="mb-4">
            <FormField element={element} documentUrls={documentUrls} />
          </div>
        );
      })}
    </div>
  );
};

export default StandardFormSection;
